import { createSelector, createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import { userUiFlowApi } from "./userUiFlow.api";

export interface UserUiFlowState {
	/** Flow keys the current user has already seen (so one-time flows are not re-shown). */
	seenKeys: string[];
	/** Whether the seen-keys query has resolved — gate UI on this to avoid a flash before it loads. */
	loaded: boolean;
}

const initialState: UserUiFlowState = {
	seenKeys: [],
	loaded: false,
};

export const userUiFlowSlice = createSlice({
	name: "userUiFlow",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(
			userUiFlowApi.endpoints.getSeenUiFlows.matchFulfilled,
			(state, { payload }) => {
				state.seenKeys = payload.data;
				state.loaded = true;
			}
		);
		builder.addMatcher(
			userUiFlowApi.endpoints.markUiFlowSeen.matchFulfilled,
			(state, { payload }) => {
				if (!state.seenKeys.includes(payload.flowKey)) {
					state.seenKeys.push(payload.flowKey);
				}
			}
		);
	},
});

export const userUiFlowReducer = userUiFlowSlice.reducer;

const selectUserUiFlow = (state: RootState) =>
	state[userUiFlowSlice.name] as UserUiFlowState | undefined;

export const userUiFlowSelector = createSelector(selectUserUiFlow, (slice) => ({
	seenKeys: slice?.seenKeys ?? [],
	loaded: slice?.loaded ?? false,
}));
